import { combineReducers } from "redux";

import { holdingConfig } from "./holding/holding.reducers";
import { migrationConfig } from "./migration/migration.reducers";

export const advanced = combineReducers({
    holdingConfig,
    migrationConfig
});